import axios, { AxiosRequestConfig } from 'axios';
import { XClientSystem } from '@inhouse-market/sdk';
import env from '../env';

const api = axios.create({
    baseURL: env.API_URL,
});

api.interceptors.request.use(async (config: AxiosRequestConfig) => {
    const { headers } = config;
    headers['x-app-version'] =
        import.meta.env.VITE_VERSION_CODE || '0.0.0-local';
    headers['x-platform'] = XClientSystem.ADMIN;
    headers['x-user-id'] = localStorage.getItem('@NeerHouse:userId') || '';
    headers['x-client-system'] = XClientSystem.ADMIN;
    return config;
});

api.prototype.Cancel = () => {
    axios.CancelToken.source();
};

export default api;
